import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {Field} from '../../workingdata/message/Field';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';
import {WidgetParameter} from './WidgetParameter';

export class Widget extends BasicEntity {
code: string;
description: TranslatedEmb;
featureCode: string;
fields: Field[];
label: TranslatedEmb;
owner: string;
parameters: WidgetParameter[];
tabCode: string;
}

